import {trigger} from '../../../utils/events/trigger';
import {pluralNumber} from '../../../utils/numerals/pluralNumber';
import {spaceNumber} from '../../../utils/numerals/spaceNumber';
import {yearsToMonths} from '../../../utils/numerals/yearsToMonths';
import {Lightbox} from '../../classes/Lightbox';

export const initMortgageCalc = () => {
	const mortgageCalc = document.querySelector( 'section.cds2-mortgage-calculator' );

	if ( !mortgageCalc )
	{
		return;
	}

	const priceInput = mortgageCalc.querySelector( 'input[name="price"]' );
	const installPaymentInput = mortgageCalc.querySelector( '[name="install_payment"]' );
	const timeInput = mortgageCalc.querySelector( 'input[name="time"]' );
	const yearInput = mortgageCalc.querySelector( 'input[name="year"]' );
	const bankInput = mortgageCalc.querySelector( 'li.banks > div.cds2-select > label' );

	const calculateMortgage = ( evt ) => {
		const banks = Array.from( document.querySelectorAll( 'section.cds2-mortgage-calculator li.bank' ) );

		if ( banks.length )
		{
			if ( evt )
			{
				mortgageCalc.querySelector( 'form' ).classList.add( 'user-changed' );
			}
			
			const price = parseInt( priceInput.value.replace( /[^0-9]+/gu, '' ), 10 );
			const installPayment = Number( installPaymentInput.value.replace( /[^0-9]+/gu, '' ) );
			const months = parseInt( yearsToMonths( timeInput.value.match( /(?<year>\d{1,2})[^\d]*(?<month>\d{1,2})?/u ) ), 10 );
			const bankTitle = mortgageCalc.querySelector( 'li.banks ul input[name*="banks"]:checked' ) ? mortgageCalc.querySelector( 'li.banks ul input[name*="banks"]:checked' ).value : 'Все';
			const requestedBanks = [];
			let validBanks = 0;

			Array.from( mortgageCalc.querySelectorAll( 'li.banks ul input[name*="banks"]' ) ).forEach( ( it ) => {
				if ( it.checked )
				{
					requestedBanks.push( it.value );
				}
			} );

			bankInput.innerHTML = requestedBanks.length > 1 ? `Выбрано ${requestedBanks.length} ${pluralNumber( requestedBanks.length, 'банк', 'банка', 'банков' )}` : bankTitle;

			banks.forEach( ( it ) => {
				let validPrograms = 0;
				let minRate = 0;
				let minPayment = 0;

				const programs = Array.from( it.querySelectorAll( 'section.cds2-mortgage-calculator tr.program' ) );

				if ( !programs.length )
				{
					return;
				}

				for ( const program of programs )
				{
					const programData = JSON.parse( program.getAttribute( 'data-json' ) );
					const rate = programData.rate / 100 / 12;
					const coefficient = programData.coefficient;
					const calculatedPrice = Math.ceil( price * coefficient );
					const requestedCredit = calculatedPrice - installPayment;
					const cpPriceMin = Number( programData.full_price_min );
					const cpPriceMax = Number( programData.full_price_max ) ? Number( programData.full_price_max ) : Infinity;
					const cpTimeMin = Number( programData.time_min );
					const cpTimeMax = Number( programData.full_price_max ) ? Number( programData.time_max ) : Infinity;
					const cpInstallPaymentMin = Math.round( price / 100 * programData.install_payment_min );
					const cpInstallPaymentMax = Number( programData.install_payment_max ) ? Math.round( price / 100 * programData.install_payment_max ) : price;

					if (
						requestedCredit <= 12000000
						&&	( requestedCredit >= cpPriceMin && requestedCredit <= cpPriceMax )
						&&	( months >= cpTimeMin && months <= cpTimeMax )
						&&	( installPayment >= cpInstallPaymentMin && installPayment <= cpInstallPaymentMax )
					)
					{
						const monthlyPayment = requestedCredit * ( ( rate ) / ( 1 - ( ( 1 + ( rate ) ) ** ( ( months - 0 ) * -1 ) ) ) );

						program.querySelector( '.montly-payment' ).innerHTML = `от&nbsp;${spaceNumber( Math.round( monthlyPayment ) )}&nbsp;₽/мес.`;
						program.querySelector( '.rate' ).innerHTML = `от ${String( programData.rate ).replace( '.', ',' )}&#8202;%`;
						program.classList.remove( 'disabled' );
						validPrograms++;

						if ( minRate === 0 || Number( minRate ) > Number( programData.rate ) )
						{
							minRate = programData.rate;
							minPayment = `от ${spaceNumber( Math.round( monthlyPayment ) )} ₽ в&nbsp;месяц`;
						}
					}
					else
					{
						program.classList.add( 'disabled' );
						program.querySelector( '.montly-payment' ).innerHTML = 'условиям расчета ипотеки';
						program.querySelector( '.rate' ).innerHTML = 'недоступна по заданным';
					}
				}

				if ( validPrograms > 0 )
				{
					mortgageCalc.querySelector( `form input[value="${it.dataset.title}"]` ).disabled = false;
				}
				else
				{
					mortgageCalc.querySelector( `form input[value="${it.dataset.title}"]` ).disabled = true;
				}

				if ( validPrograms > 0 && ( bankTitle === 'Все' || requestedBanks.indexOf( it.dataset.title ) > -1 ) )
				{
					it.dataset.validCount = validPrograms;
					it.querySelector( 'label span' ).innerHTML = `${validPrograms} ${pluralNumber( validPrograms, 'программа', 'программы', 'программ' )}`;
					it.querySelector( 'ul li.rate' ).innerHTML = `от ${String( minRate ).replace( '.', ',' )}&#8202;%`;
					it.querySelector( 'ul li.payment' ).innerHTML = minPayment;
					it.classList.remove( 'disabled' );
					validBanks++;
				}
				else
				{
					it.classList.add( 'disabled' );
					it.querySelector( 'label span' ).innerHTML = 'Нет программ';
					it.querySelector( 'ul li.rate' ).innerHTML = '';
					it.querySelector( 'ul li.payment' ).innerHTML = '';
				}
			} );

			mortgageCalc.querySelector( 'ul.banks' ).dataset.validBanks = validBanks;
		}

		const cardsPairs = Array.from( document.querySelectorAll( 'section.cds2-mortgage-calculator ul.programs-cards' ) );

		if ( cardsPairs.length )
		{
			cardsPairs.forEach( ( it ) => {
				const cards = Array.from( it.children );
		
				if ( cards.length )
				{
					if ( evt )
					{
						mortgageCalc.querySelector( 'form' ).classList.add( 'user-changed' );
					}
					
					const price = parseInt( priceInput.value.replace( /[^0-9]+/gu, '' ), 10 );
					const installPayment = Number( installPaymentInput.value.replace( /[^0-9]+/gu, '' ) );
					const months = parseInt( yearsToMonths( yearInput.value.match( /(?<year>\d{1,2})[^\d]*(?<month>\d{1,2})?/u ) ), 10 );
					let basicP = 0;
					let promoP = 0;
					let basicMP = 0;
					let promoMP = 0;
					let basicOP = 0;
					let promoOP = 0;

					for ( const program of cards )
					{
						const isPromo = program.classList.contains( 'promo' );
						const programData = JSON.parse( program.getAttribute( 'data-json' ) );
						const rate = mortgageCalc.querySelector( 'input[name="family_conditions"]' ).checked ? programData.family_rate / 100 / 12 : programData.rate / 100 / 12;
						const coefficient = mortgageCalc.querySelector( 'input[name="family_conditions"]' ).checked ? programData.family_coefficient : programData.coefficient;
						const calculatedPrice = Math.ceil( price * coefficient );
						const minInstallPayment = calculatedPrice - installPayment <= 12000000 ? Math.ceil( calculatedPrice * ( programData.install_payment_min / 100 ) ) : calculatedPrice - 12000000;
						let requestedCredit = installPayment >= minInstallPayment ? calculatedPrice - installPayment : calculatedPrice - minInstallPayment;
						const monthlyPayment = requestedCredit * ( ( rate ) / ( 1 - ( ( 1 + ( rate ) ) ** ( ( months - 0 ) * -1 ) ) ) );
						let percentPayment = 0;
						let percentPaymentTotal = 0;

						if ( mortgageCalc.querySelector( 'input[name="family_conditions"]' ).checked )
						{
							program.querySelector( 'h3' ).innerHTML = `«Семейная ипотека» ${programData.family_rate.replace( '.', ',' )}%`;
						}
						else
						{
							program.querySelector( 'h3' ).innerHTML = `${programData.title} ${programData.rate.replace( '.', ',' )}%`;
						}

						const monthsToCount = isPromo && it.dataset.bank === 'rosbank' ? 120 : months;

						for ( let i = monthsToCount; i > 0; i-- )
						{
							percentPayment = requestedCredit * rate;
							requestedCredit -= monthlyPayment - percentPayment;
							percentPaymentTotal += percentPayment;
						}

						if ( isPromo && it.dataset.bank === 'rosbank' )
						{
							const newRate = 6.7 / 100 / 12;
							const newMonthlyPayment = requestedCredit * ( ( newRate ) / ( 1 - ( ( 1 + ( newRate ) ) ** ( ( months - monthsToCount - 0 ) * -1 ) ) ) );

							for ( let y = months - monthsToCount; y > 0; y-- )
							{
								percentPayment = requestedCredit * newRate;
								requestedCredit -= newMonthlyPayment - percentPayment;
								percentPaymentTotal += percentPayment;
							}

							program.querySelector( '.montly-payment-further strong' ).innerHTML = `${spaceNumber( Math.round( newMonthlyPayment ) )} ₽`;
						}

						if ( isPromo )
						{
							promoP = Math.ceil( price * 1.302 );
							promoMP = monthlyPayment;
							promoOP = percentPaymentTotal;
						}
						else
						{
							basicP = price;
							basicMP = monthlyPayment;
							basicOP = percentPaymentTotal;
						}

						program.querySelector( '.montly-payment strong' ).innerHTML = `${spaceNumber( Math.round( monthlyPayment ) )} ₽`;
						program.querySelector( '.overpay strong' ).innerHTML = `${spaceNumber( Math.round( percentPaymentTotal ) )} ₽`;
					}

					for ( const program of cards )
					{
						const isPromo = program.classList.contains( 'promo' );
						const econ = basicOP - promoOP - ( promoP - basicP ) > 0 ? Math.round( basicOP - promoOP - ( promoP - basicP ) ) : 0;
						
						program.querySelector( '.montly-payment span.note' ).innerHTML = `${( isPromo && promoMP < basicMP ) || ( !isPromo && promoMP > basicMP ) ? 'Меньше' : 'Больше'} на&nbsp;${spaceNumber( Math.round( Math.abs( promoMP - basicMP ) ) )}&nbsp;₽`;
						program.querySelector( '.overpay span.note' ).innerHTML = `${( isPromo && promoOP < basicOP ) || ( !isPromo && promoOP > basicOP ) ? 'Меньше' : 'Больше'} на&nbsp;${spaceNumber( Math.round( Math.abs( promoOP - basicOP ) ) )}&nbsp;₽`;
						program.querySelector( '.result' ).innerHTML = ( isPromo && promoOP < basicOP ) || ( !isPromo && promoOP > basicOP ) ? `${spaceNumber( econ )}&nbsp;₽ <span class="label">Экономия</span>` : '0 ₽ <span class="label">Без&nbsp;экономии</span>';

						if ( ( isPromo && promoMP > basicMP ) || ( !isPromo && promoMP > basicMP ) )
						{
							program.querySelector( '.montly-payment span.note' ).classList.add( 'inverse' );
						}
						else
						{
							program.querySelector( '.montly-payment span.note' ).classList.remove( 'inverse' );
						}

						if ( ( isPromo && promoOP > basicOP ) || ( !isPromo && promoOP > basicOP ) )
						{
							program.querySelector( '.overpay span.note' ).classList.add( 'inverse' );
						}
						else
						{
							program.querySelector( '.overpay span.note' ).classList.remove( 'inverse' );
						}
					}
				}
			} );
		}

		const managerCards = Array.from( document.querySelectorAll( 'section.cds2-mortgage-calculator ul.comparison-card' ) );

		if ( managerCards.length )
		{
			managerCards.forEach( ( card ) => {
				const cardPrograms = Array.from( card.children );
		
				if ( !cardPrograms.length )
				{
					return;
				}

				if ( evt )
				{
					mortgageCalc.querySelector( 'form' ).classList.add( 'user-changed' );
				}
				
				const price = parseInt( priceInput.value.replace( /[^0-9]+/gu, '' ), 10 );
				const installPayment = Number( installPaymentInput.value.replace( /[^0-9]+/gu, '' ) );
				const months = parseInt( yearsToMonths( yearInput.value.match( /(?<year>\d{1,2})[^\d]*(?<month>\d{1,2})?/u ) ), 10 );

				for ( const program of cardPrograms )
				{
					const isPromo = program.classList.contains( 'promo' );
					const programData = JSON.parse( program.getAttribute( 'data-json' ) );
					const rate = mortgageCalc.querySelector( 'input[name="family_conditions"]' ).checked ? programData.family_rate / 100 / 12 : programData.rate / 100 / 12;
					const coefficient = mortgageCalc.querySelector( 'input[name="family_conditions"]' ).checked ? programData.family_coefficient : programData.coefficient;
					const calculatedPrice = Math.ceil( price * coefficient );
					const minInstallPayment = calculatedPrice - installPayment <= 12000000 ? Math.ceil( calculatedPrice * ( programData.install_payment_min / 100 ) ) : calculatedPrice - 12000000;
					let requestedCredit = installPayment >= minInstallPayment ? calculatedPrice - installPayment : calculatedPrice - minInstallPayment;

					const monthlyPayment = requestedCredit * ( ( rate ) / ( 1 - ( ( 1 + ( rate ) ) ** ( ( months - 0 ) * -1 ) ) ) );
					let percentPayment = 0;
					let percentPaymentTotal = 0;

					if ( isPromo && Math.round( Number( installPaymentInput.value.replace( /\D/gu, '' ) ) / calculatedPrice * 100 ) < card.dataset.minPayment )
					{
						program.querySelector( 'ul' ).classList.add( 'disabled' );
						program.querySelector( 'ul' ).dataset.minPayment = `Доступна при минимальном взносе ${spaceNumber( Math.round( calculatedPrice / 100 * card.dataset.minPayment ) )} ₽`;
					}
					else
					{
						program.querySelector( 'ul' ).classList.remove( 'disabled' );
					}

					if ( mortgageCalc.querySelector( 'input[name="family_conditions"]' ).checked )
					{
						program.querySelector( 'h3' ).innerHTML = `«Семейная ипотека» ${programData.family_rate.replace( '.', ',' )}%`;
					}
					else
					{
						program.querySelector( 'h3' ).innerHTML = `${programData.title} ${programData.rate.replace( '.', ',' )}%`;
					}

					const monthsToCount = isPromo && card.dataset.bank === 'rosbank' ? 120 : months;

					for ( let i = monthsToCount; i > 0; i-- )
					{
						percentPayment = requestedCredit * rate;
						requestedCredit -= monthlyPayment - percentPayment;
						percentPaymentTotal += percentPayment;
					}

					if ( isPromo && card.dataset.bank === 'rosbank' )
					{
						const newRate = 6.7 / 100 / 12;
						const newMonthlyPayment = requestedCredit * ( ( newRate ) / ( 1 - ( ( 1 + ( newRate ) ) ** ( ( months - monthsToCount - 0 ) * -1 ) ) ) );

						for ( let y = months - monthsToCount; y > 0; y-- )
						{
							percentPayment = requestedCredit * newRate;
							requestedCredit -= newMonthlyPayment - percentPayment;
							percentPaymentTotal += percentPayment;
						}

						program.querySelector( '.montly-payment-further strong' ).innerHTML = `${spaceNumber( Math.round( newMonthlyPayment ) )} ₽`;
					}

					if ( program.querySelector( '.subsidized-sum strong' ) )
					{
						program.querySelector( '.subsidized-sum strong' ).innerHTML = `${spaceNumber( Math.round( calculatedPrice ) )} ₽`;
					}
					
					program.querySelector( '.montly-payment strong' ).innerHTML = `${spaceNumber( Math.round( monthlyPayment ) )} ₽`;
					program.querySelector( '.overpay strong' ).innerHTML = `${spaceNumber( Math.round( percentPaymentTotal ) )} ₽`;
					program.querySelector( '.whole-sum strong' ).innerHTML = `${spaceNumber( Math.round( calculatedPrice + percentPaymentTotal ) )} ₽`;
				}

				if ( Number( yearInput.value.replace( /\D/gu, '' ) ) > card.dataset.maxTime )
				{
					card.classList.add( 'years-disabled' );
				}
				else
				{
					card.classList.remove( 'years-disabled' );
				}

				if ( Math.round( Number( installPaymentInput.value.replace( /\D/gu, '' ) ) / Number( priceInput.value.replace( /\D/gu, '' ) ) * 100 ) < card.dataset.minPayment )
				{
					card.classList.add( 'percents-disabled' );
				}
				else
				{
					card.classList.remove( 'percents-disabled' );
				}
			} );
		}
	};

	calculateMortgage();

	const inputs = Array.from( mortgageCalc.querySelectorAll( 'form input' ) );

	if ( !inputs.length )
	{
		return;
	}

	for ( const input of inputs )
	{
		input.addEventListener( 'change', calculateMortgage );
	}

	const banksInputs = Array.from( mortgageCalc.querySelectorAll( 'input[name*="mortgage-calculator-bank"]' ) );

	if ( !banksInputs )
	{
		return;
	}

	for ( const input of banksInputs )
	{
		input.addEventListener( 'change', ( evt ) => {
			const requestedBank = evt.target.value;
			const currentCoeff = mortgageCalc.querySelector( `ul.programs-cards[data-bank="${requestedBank}"]` ).dataset.coefficient;

			mortgageCalc.querySelector( 'form' ).dataset.coefficient = currentCoeff;
			mortgageCalc.querySelector( 'form li.install_payment div.cds2-range-one' ).dataset.min = mortgageCalc.querySelector( `ul.programs-cards[data-bank="${requestedBank}"]` ).dataset.minPayment;
			mortgageCalc.querySelector( 'form li.year div.cds2-range-one' ).dataset.max = mortgageCalc.querySelector( `ul.programs-cards[data-bank="${requestedBank}"]` ).dataset.maxTime;

			trigger( mortgageCalc.querySelector( 'form input[name="price"]' ), 'keydown' );
		} );
	}

	mortgageCalc.addEventListener( 'click', ( evt ) => {
		const bank = evt.target.closest( 'li.bank' );

		if ( !bank || window.innerWidth > 635 )
		{
			return;
		}

		const lightboxContent = bank.innerHTML;

		Lightbox.open( lightboxContent, null, 'tooltip' );
	} );
};
